import { makeStyles } from "@material-ui/core";
import {
  Box,
  Card,
  Dialog,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { FC, useEffect } from "react";
import ForcastIcon from "src/assets/forecastIcon.svg";
import ActualUsageIcon from "src/assets/retrieveactual.svg";
import SmtUsageIcon from "src/assets/smart-meter.svg";
import { graph2 } from "src/mock/graph";
import { useDispatch, useSelector } from "src/store";
import {
  getForecastUsage,
  setShowRateGraphInStore,
} from "src/slices/bkvReducer";
import SubmitLoader from "../SubmitLoader";

export default ({ handleClose, changeView }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const state = useSelector((state) => state.bkv);

  const handleForcast = async () => {
    // TODO: fetch estimated usage
    dispatch(setShowRateGraphInStore(false));
    await dispatch(
      getForecastUsage(() => {
        handleClose("usageModal");
      })
    );
  };

  return (
    <>
      <Card className={classes.root}>
        <IconButton
          className={classes.crossIcon}
          onClick={() => handleClose("usageModal")}
        >
          <CloseIcon fontSize="large" />
        </IconButton>
        <Typography
          align="center"
          fontSize={{ xs: "3.5vw", sm: "3.5vw", md: "3.5vw", lg: "30px" }}
          className={classes.title}
          variant="body2"
        >
          Discover how much you can save
        </Typography>
        <Typography
          align="center"
          fontSize={{ xs: "3.5vw", sm: "3.5vw", md: "3.5vw", lg: "20px" }}
          className={classes.title}
          variant="body1"
        >
          (spoiler, it could be a lot!)
        </Typography>

        <Box className={classes.forcastContainer} onClick={handleForcast}>
          <img width="40vw" src={ForcastIcon} alt="forcast-icon" />
          <Box className={classes.forcast}>
            <Typography
              fontSize={{ xs: "3.5vw", sm: "3.5vw", md: "3.5vw", lg: "20px" }}
              className="heading"
            >
              <b>Forecast my usage and view all now</b>
            </Typography>
            <Typography
              fontSize={{ xs: "3.5vw", sm: "3.5vw", md: "3.5vw", lg: "20px" }}
              className="subtitle"
            >
              Instant access of your usage history through smart meter number
            </Typography>
          </Box>
        </Box>

        <Divider className={classes.divider}>
          <Typography
            fontSize={{ xs: "3.5vw", sm: "3.5vw", md: "3.5vw", lg: "20px" }}
          >
            or
          </Typography>
        </Divider>

        <Box>
          <Typography
            fontSize={{ xs: "3.5vw", sm: "3.5vw", md: "3.5vw", lg: "20px" }}
            className="title"
          >
            To provide you with the most suitable plan, we need to know your
            usage patterns.
          </Typography>
          <Box className="options">
            <Box
              className={classes.optionContainer}
              onClick={() => changeView("tdu")}
            >
              <img width="40vw" src={ActualUsageIcon} alt="actual-usage-icon" />
              <Box className={classes.forcast}>
                <Typography
                  fontSize={{
                    xs: "3.5vw",
                    sm: "3.5vw",
                    md: "3.5vw",
                    lg: "20px",
                  }}
                  className="heading"
                >
                  <b>Retrieve my actual usage</b>
                </Typography>
                <Typography
                  fontSize={{
                    xs: "3.5vw",
                    sm: "3.5vw",
                    md: "3.5vw",
                    lg: "20px",
                  }}
                  className="subtitle"
                >
                  Quickest way to pull usage pattern from your utility account
                </Typography>
              </Box>
            </Box>
            <Box
              className={classes.optionContainer}
              onClick={() => changeView("smt")}
            >
              <img width="40vw" src={SmtUsageIcon} alt="smt-usage-icon" />
              <Box className={classes.forcast}>
                <Typography
                  fontSize={{
                    xs: "3.5vw",
                    sm: "3.5vw",
                    md: "3.5vw",
                    lg: "20px",
                  }}
                  className="heading"
                >
                  <b>Use Smart Meter Texas (SMT) data</b>
                </Typography>
                <Typography
                  fontSize={{
                    xs: "3.5vw",
                    sm: "3.5vw",
                    md: "3.5vw",
                    lg: "20px",
                  }}
                  className="subtitle"
                >
                  Instant access of your usage history through smart meter
                  number
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Card>
      <SubmitLoader open={state.loading} />
    </>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    // width: 900,
    // height: 744,
    padding: 45,
    overflowY: "scroll",
  },
  crossIcon: {
    transform: "scale(0.8)",
    position: "absolute",
    top: 15,
    right: 20,
  },
  title: {
    textA3vwlign: "center",
    color: "#09507F",
  },
  forcastContainer: {
    transition: "all 0.6 ease",
    cursor: "pointer",
    marginTop: 20,
    // width: 757,
    backgroundColor: "#e5f5f3",
    display: "flex",
    padding: 18,
    borderRadius: 24,
    border: "1px solid #009A88",
    "&:hover": {
      backgroundColor: "#eafffc",
      boxShadow: "1px 5px 5px 5px #888888",
    },
  },
  forcast: {
    display: "flex",
    flexDirection: "column",
    marginLeft: 20,
    "& .heading": {
      fon3vwtWeight: "bold",
    },
  },
  divider: {
    margin: "30px 0px 25px 0px",
    "& span": {
      padding: "0 32px",
    },
    "& p": {
      color: "#808080",
    },
  },
  optionContainer: {
    cursor: "pointer",
    marginTop: 20,
    // width: 757,
    display: "flex",
    padding: 18,
    borderRadius: 24,
    border: "1px solid #009A88",
    "&:hover": {
      backgroundColor: "#eafffc",
      boxShadow: "1px 5px 5px 5px #888888",
    },
  },
}));
